/* ============
 * Templates State
 * ============
 *
 * The state of the templates module.
 */

export default {
  all: [],
  pagination: {
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    limit: 20,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/templates/state.js